import React from 'react';

let monoIdCounter = 0;

export const MonobankIcon = ({ size = 16, style, ...props }) => {
  const [ids] = React.useState(() => {
    const n = ++monoIdCounter;
    return { grad: `mono_grad_${n}`, clip: `mono_clip_${n}` };
  });
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}
    >
      <g clipPath={`url(#${ids.clip})`}>
        <path d="M33.219 0.0605469H6.75236C3.07046 0.0605469 0.0856934 3.04532 0.0856934 6.72721V33.2172C0.0856934 36.8991 3.07046 39.8839 6.75236 39.8839H33.219C36.9009 39.8839 39.8857 36.8991 39.8857 33.2172V6.72721C39.8857 3.04532 36.9009 0.0605469 33.219 0.0605469Z" fill={`url(#${ids.grad})`} />
        <path d="M13.3677 23.1069V18.6166C13.3677 17.3429 12.6857 16.7383 11.541 16.7383C10.5887 16.7383 9.76537 17.3043 9.40504 17.8703C9.17337 17.1626 8.59437 16.7383 7.68104 16.7383C6.7287 16.7383 5.90537 17.3299 5.64804 17.7033V16.8926H4.01404V23.1066H5.64804V18.9256C5.89237 18.5783 6.36871 18.1923 6.93471 18.1923C7.60371 18.1923 7.86104 18.604 7.86104 19.183V23.1066H9.5077V18.9126C9.73937 18.5779 10.2154 18.1919 10.7944 18.1919C11.4634 18.1919 11.721 18.6036 11.721 19.1826V23.1066L13.3677 23.1069ZM17.858 23.2613C15.8124 23.2613 14.5774 21.769 14.5774 19.9933C14.5774 18.2306 15.8124 16.7383 17.858 16.7383C19.9167 16.7383 21.1517 18.2306 21.1517 19.9933C21.1517 21.769 19.9167 23.2613 17.858 23.2613ZM17.858 21.8076C18.8747 21.8076 19.4534 20.971 19.4534 19.9933C19.4534 19.0283 18.8744 18.1923 17.858 18.1923C16.8414 18.1923 16.2754 19.0283 16.2754 19.9933C16.2754 20.9713 16.8417 21.8076 17.858 21.8076ZM28.1894 23.1069V18.7196C28.1894 17.5103 27.5334 16.7383 26.1694 16.7383C25.1527 16.7383 24.394 17.2273 23.995 17.7033V16.8926H22.361V23.1069H23.995V18.9256C24.265 18.5523 24.767 18.1923 25.4104 18.1923C26.105 18.1923 26.5554 18.4883 26.5554 19.3503V23.1069H28.1894ZM32.6924 23.2613C30.6467 23.2613 29.4117 21.769 29.4117 19.9933C29.4117 18.2306 30.6467 16.7383 32.6924 16.7383C34.751 16.7383 35.986 18.2306 35.986 19.9933C35.986 21.769 34.751 23.2613 32.6924 23.2613ZM32.6924 21.8076C33.709 21.8076 34.2877 20.971 34.2877 19.9933C34.2877 19.0283 33.7087 18.1923 32.6924 18.1923C31.6757 18.1923 31.1097 19.0283 31.1097 19.9933C31.1097 20.9713 31.676 21.8076 32.6924 21.8076Z" fill="white" />
      </g>
      <defs>
        <linearGradient id={ids.grad} x1="20.4474" y1="0.533547" x2="20.4474" y2="39.3295" gradientUnits="userSpaceOnUse">
          <stop stopColor="#373B45" />
          <stop offset="1" stopColor="#181A1D" />
        </linearGradient>
        <clipPath id={ids.clip}>
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ABankIcon = ({ size = 16, style, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    {...props}
  >
    <circle cx="20" cy="20" r="20" fill="#00D352" />
    <path d="M21.6279 13.1739L19.8159 10H16.1684L18.6839 13.1739H21.6279ZM26.2443 14.7375H23.0479V15.6482C22.0464 14.9991 20.8756 14.6047 19.6218 14.6047C15.9627 14.6039 13 17.5363 13 21.1481C13 24.7637 15.9666 27.6914 19.6225 27.6914C20.8756 27.6914 22.0472 27.2962 23.0479 26.6433V27.5548H26.2443V14.7375ZM19.6218 24.6465C17.6676 24.6465 16.0815 23.0782 16.0815 21.1481C16.0815 19.2172 17.6676 17.6497 19.6218 17.6497C21.5759 17.6497 23.1621 19.2133 23.1621 21.1481C23.1582 23.0789 21.5759 24.6465 19.6218 24.6465Z" fill="black" />
  </svg>
);
